import Vue from "vue";
import Vuex from "vuex";
import {
  getLoginUrl,
  getLoginToken,
  getLoginInit,
  getUserInfo,
  loginOut,
} from "./apis/info";
import {
  getTableList,
  onPublish,
  onDelete,
  onPaused,
  onEnd,
  createAct,
  getRecordTableList,
  actDetail,
  copyUrl,
  getLogTableList,
  setMemberLink,
} from "./apis/act";
import { getCategory, getImageList } from "./apis/images";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    expireDate: localStorage.getItem("ExpireDate"),
    app_url: "",
    userInfo: {
      member_join_url: "",
    },
  },
  mutations: {
    setExpireDate(state, data) {
      state.expireDate = data;
      localStorage.setItem("ExpireDate", data);
    },
    setActID(state, data) {
      state.app_url = data.applet_url;
    },
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setMemberLink(state, data) {
      state.userInfo.member_join_url = data.bind_url;
    },
  },
  actions: {
    async getLoginUrl(context: any, data: any) {
      const url = await getLoginUrl(data);
      return url;
    },
    async loginOut(context: any, data: any) {
      const url = await loginOut(data);
      return url;
    },
    async getLoginToken(context: any, data: any) {
      const token = await getLoginToken(data);
      return token;
    },
    async setExpireDate(context: any, data: any) {
      context.commit("setExpireDate", data);
    },
    async getLoginInit(context: any, data: any) {
      const token = await getLoginInit(data);
      return token;
    },
    async getUserInfo(context: any, data: any) {
      const info = await getUserInfo(data);
      context.commit("setUserInfo", info);
      return info;
    },

    async setMemberLink(context: any, data: any) {
      await setMemberLink(data);
      context.commit("setMemberLink", data);
    },

    async getTableList(context: any, data: any) {
      const list = await getTableList(data);
      return list;
    },
    async getRecordTableList(context: any, data: any) {
      const list = await getRecordTableList(data);
      return list;
    },
    async getLogTableList(context: any, data: any) {
      const list = await getLogTableList(data);
      return list;
    },
    async onPublish(context: any, data: any) {
      await onPublish(data);
    },
    async onDelete(context: any, data: any) {
      await onDelete(data);
    },
    async onPaused(context: any, data: any) {
      await onPaused(data);
    },
    async onEnd(context: any, data: any) {
      await onEnd(data);
    },

    async createAct(context: any, data: any) {
      const ACT_ID = await createAct(data);
      context.commit("setActID", ACT_ID);
      return ACT_ID;
    },
    async actDetail(context: any, data: any) {
      const detail = await actDetail(data);
      return detail;
    },
    async copyUrl(context: any, data: any) {
      const url = await copyUrl(data);
      return url;
    },
    async getCategory(context: any, data: any) {
      const category = await getCategory(data);
      return category;
    },
    async getImageList(context: any, data: any) {
      const imageList = await getImageList(data);
      return imageList;
    },
  },
  modules: {},
});
